import Chart from 'chartjs';
import moment from 'moment';
import i18n from 'l10n';
import ch from 'libs/chart-helpers';
import Handlebars from 'handlebars';
import {_, Backbone} from 'backboneAdapter';
import {mixin, on} from "../adapters/backbone-decorators";

var isPostpaid = false;

const MiniView = _.pick(Backbone.View.prototype, "delegate", "undelegate", "delegateEvents", "undelegateEvents", "$");

@mixin(MiniView)
class ReportMessageChartSimpleView {
    /* TODO Replace with model fetch */

    pingUrl = '/CampaignCloud/UserInfo';

    options = {
        from: null, //moment
        to: null, //moment
        window: null,
        fromAll: null,
        toAll: null,
        unitAll: null,
        queryOptions: {
            from: null, //long millis
            to: null, //long millis
            unit: null,
            window: null,
            dow: null //first day of week (0-Sunday ...)
        }
    };

    division = {
        all: {divisions: ['month'], def: 'month'},
        day: {divisions: ['hour'], def: 'hour'},
        week: {divisions: ['day'], def: 'day'},
        month: {divisions: ['week', 'day'], def: 'day'},
        year: {divisions: ['month', 'week'], def: 'month'}
    };

    moreLessDetails(inc) {
        var division = this.division[this.options.window];
        var curr = _.indexOf(division.divisions, this.options.queryOptions.unit);
        if (curr >= 0 && curr + inc >= 0 && curr + inc < division.divisions.length) { //paranoid check
            this.options.queryOptions.unit = division.divisions[curr + inc];
            $(this.selector).find(".zoom-buttons").find('button').removeClass('disabled');
            if (this.options.queryOptions.unit === _.first(division.divisions)) {
                $(this.selector).find(".zoom-buttons").find('.minus').addClass('disabled');
            } else if (this.options.queryOptions.unit === _.last(division.divisions)) {
                $(this.selector).find(".zoom-buttons").find('.plus').addClass('disabled');
            }
            this.refresh();
        }
    }

    getAppropriatePercentageValue(val, charNumb) {
        if(val < 1 && val > 0) {
            return val.toFixed(2);
        }
        return val.toFixed(charNumb);
    }

    setWindow(timegranule) {
        var now = moment();
        var previousWindow = this.options.window;
        var goingToDayFromEnclosingWindow = this.options.window !== 'day' && timegranule === "day" && now.isBetween(this.options.from, this.options.to);
        if (timegranule === "*day") timegranule = "day";

        this.options.window = timegranule;
        this.options.queryOptions.window = timegranule;
        var division = this.division[timegranule];
        this.options.queryOptions.unit = division.def;
        if (division.divisions.length === 1) {
            $(this.selector).find(".zoom-buttons").find('button').addClass('disabled');
        } else {
            $(this.selector).find(".zoom-buttons").find('button').removeClass('disabled');
            if (this.options.queryOptions.unit === _.first(division.divisions)) {
                $(this.selector).find(".zoom-buttons").find('.minus').addClass('disabled');
            } else if (this.options.queryOptions.unit === _.last(division.divisions)) {
                $(this.selector).find(".zoom-buttons").find('.plus').addClass('disabled');
            }
        }
        if (timegranule === 'all') {
            this.options.queryOptions.unit = this.options.unitAll;
            this.options.from = this.options.fromAll;
            this.options.to = this.options.toAll;
            this.options.queryOptions.from = this.options.from.toDate().getTime();
            this.options.queryOptions.to = this.options.to.toDate().getTime();
            $(this.selector).find('.pagination').find('li').addClass('disabled');
            $(this.selector).find('.pagination').find('.spaces').html(i18n.t('reports.allbutton'));
        } else {

            if(previousWindow == null){
                //Set starting timeframe the start of current timeframe,
                //When loading the page for the first time
                this.options.from = now.startOf(timegranule);
            }

            var startOf = previousWindow !== 'month' && goingToDayFromEnclosingWindow ? now.startOf("day") : this.options.from.clone().startOf(this.options.window);
            this.options.from = startOf;
            this.options.queryOptions.from = startOf.toDate().getTime();
            var endOf = startOf.clone().endOf(this.options.window);
            this.options.to = endOf;
            this.options.queryOptions.to = endOf.toDate().getTime();

            var startOfString = startOf.format('ll');
            var endOfString = endOf.format('ll');
            $(this.selector).find('.pagination').find('li').removeClass('disabled');
            $(this.selector).find('.pagination').find('.spaces').html(`${startOfString} - ${endOfString}`);
        }
    }

    async init(selector, options) {
        if (options) {
            this.options = options;
        }
        this.options.queryOptions.dow = moment().localeData().firstDayOfWeek();

        this.selector = selector;

        $(this.selector).find(".timegranule-buttons").buttongroup({
            click: (btn, on) => {
                if (btn.data) { //For some weird reason, it is being called twice, once correctly and one more time with an Event param...
                    var tg = btn.data("timegranule");
                    this.setWindow(tg);
                    this.refresh();
                }
            }
        });

        // $(this.selector).find('.pagination').find('.prev').on('click', this.prevPage);
        // $(this.selector).find('.pagination').find('.next').on('click', this.nextPage);
        // $(this.selector).find(".zoom-buttons").find('.minus').on('click', this.zoomOut);
        // $(this.selector).find(".zoom-buttons").find('.plus').on('click', this.zoomIn);

        if (!options) {
            try {
                const json = await $.ajaxDefaultQ({
                    url: this.pingUrl,
                    type: 'GET',
                    contentType: 'application/json',
                    dataType: 'json'
                });
                if (json.noData === "No data") {
                    console.log("no data");
                } else {
                    var dateFrom = moment(json.creationDate.millis).startOf('month');
                    var one_day = 1000 * 60 * 60 * 24;
                    this.options.fromAll = dateFrom;
                    var date2_ms = moment().toDate().getTime();
                    var difference_ms = date2_ms - dateFrom;
                    // Convert back to days and check
                    if (Math.round(difference_ms / one_day) < 30) {
                        this.options.unitAll = "day";
                    }
                    /*else if(Math.round(difference_ms/one_day)<49){
                    self.options.unitAll = "week";
                }*/
                    else {
                        this.options.unitAll = "month";
                    }
                    this.options.toAll = moment().endOf(this.options.unitAll === 'day' ? 'day' : 'month');

                    isPostpaid = json.postpaid;

                    $(this.selector).find(".timegranule-buttons").find("[data-timegranule='week']").addClass('active');

                    this.setWindow('week');
                    this.refresh();
                }
            } catch (e) {
                console.error(e);
            }

        } else {
            this.refresh();
        }

        this.$el = $(this.selector);
        this.undelegateEvents();
        this.delegateEvents();
    }

    @on("click .zoom-buttons .minus")
    zoomOut(e) {
        if (!$(e.currentTarget).hasClass('disabled')) {
            this.moreLessDetails(-1);
        }
    }

    @on("click .zoom-buttons .plus")
    zoomIn(e) {
        if (!$(e.currentTarget).hasClass('disabled')) {
            this.moreLessDetails(+1);
        }
    }

    @on('click .pagination .prev')
    prevPage(e) {
        if (!$(e.currentTarget).hasClass('disabled')) {
            this.options.from.subtract(1, this.options.window + 's');
            this.setWindow(this.options.window);
            this.refresh();
        }
    }

    @on('click .pagination .next')
    nextPage(e) {
        if (!$(e.currentTarget).hasClass('disabled')) {
            this.options.from.add(1, this.options.window + 's');
            this.setWindow(this.options.window);
            this.refresh();
        }
    }

    handler1(json) {
        //TODO Refactoring needed to discard duplicates and unused data.
        json.spends.forEach(function (item, index) {
            json.spends[index] = parseFloat(parseFloat(json.spends[index]).toFixed(2));
        });

        const self = this;
        if (json.unit) {
            $(self.selector).find('#messageChartXAxisLabel').text(i18n.t("reports.label-" + json.unit));
        }

        var adder = function (a, b) {
            return a + b;
        };
        var creditsSpent = json.spends.reduce(adder);
        var sms = json.sms.reduce(adder);
        var email = json.emails.reduce(adder);

        var emailsUndelivered = json.emailsUndelivered.reduce(adder);

        $(self.selector).find("#credit-sum-1-last-week").show().text(parseFloat(creditsSpent).toFixed(2));
        var cl = Handlebars.helpers.dynamicFontSize(creditsSpent.toFixed(2), $(self.selector).find("#credit-sum-1-last-week").data("font-length"));
        $(self.selector).find("#credit-sum-1-last-week").addClass(cl.toString());
        $(self.selector).find("#credit-text-last-week").text(i18n.t("dashboard.credits", {count: creditsSpent}));

        $(self.selector).find("#sms-sent-count_1-last-week").show().text(sms);
        cl = Handlebars.helpers.dynamicFontSize(sms, $(self.selector).find("#sms-sent-count_1-last-week").data("font-length"));
        $(self.selector).find("#sms-sent-count_1-last-week").addClass(cl.toString());

        $(self.selector).find("#email-sent-count_1-last-week").show().text(email);
        cl = Handlebars.helpers.dynamicFontSize(email, $(self.selector).find("#email-sent-count_1-last-week").data("font-length"));
        $(self.selector).find("#email-sent-count_1-last-week").addClass(cl.toString());

        if (self.messageChart) {
            self.messageChart.destroy();
        }
        var labels = i18n.labels(self.options.from, self.options.window, self.options.queryOptions.unit, json.sms.length);


        var datasets;
        if (isPostpaid) {
            datasets = [
                {
                    label: i18n.t('reports.smslabel'),
                    fillColor: ch.colors.mauveUno.transparent,
                    strokeColor: ch.colors.mauveUno.solid,
                    pointColor: ch.colors.mauveUno.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.mauveUno.solid,
                    data: json.sms
                },
                {
                    label: i18n.t('reports.smsundellabel'),
                    fillColor: ch.colors.blueDue.transparent,
                    strokeColor: ch.colors.blueDue.solid,
                    pointColor: ch.colors.blueDue.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.blueDue.solid,
                    data: json.smsUndelivered
                },
                {
                    label: i18n.t('reports.emaillabel'),
                    fillColor: ch.colors.greenTre.transparent,
                    strokeColor: ch.colors.greenTre.solid,
                    pointColor: ch.colors.greenTre.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.greenTre.solid,
                    data: json.emails
                },
                {
                    label: i18n.t('reports.emailunknownlabel'),
                    fillColor: ch.colors.orangeCinque.transparent,
                    strokeColor: ch.colors.orangeCinque.solid,
                    pointColor: ch.colors.orangeCinque.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.orangeCinque.solid,
                    data: json.emailsUndelivered
                }
            ];
        } else {
            datasets = [
                {
                    label: i18n.t('reports.smslabel'),
                    fillColor: ch.colors.mauveUno.transparent,
                    strokeColor: ch.colors.mauveUno.solid,
                    pointColor: ch.colors.mauveUno.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.mauveUno.solid,
                    data: json.sms
                },
                {
                    label: i18n.t('reports.smsundellabel'),
                    fillColor: ch.colors.blueDue.transparent,
                    strokeColor: ch.colors.blueDue.solid,
                    pointColor: ch.colors.blueDue.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.blueDue.solid,
                    data: json.smsUndelivered
                },
                {
                    label: i18n.t('reports.emaillabel'),
                    fillColor: ch.colors.greenTre.transparent,
                    strokeColor: ch.colors.greenTre.solid,
                    pointColor: ch.colors.greenTre.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.greenTre.solid,
                    data: json.emails
                },
                {
                    label: i18n.t('reports.emailunknownlabel'),
                    fillColor: ch.colors.orangeCinque.transparent,
                    strokeColor: ch.colors.orangeCinque.solid,
                    pointColor: ch.colors.orangeCinque.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.orangeCinque.solid,
                    data: json.emailsUndelivered
                },
                {
                    label: i18n.t('dashboard.credits-spent'),
                    fillColor: ch.colors.peachQuattro.transparent,
                    strokeColor: ch.colors.peachQuattro.solid,
                    pointColor: ch.colors.peachQuattro.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.peachQuattro.solid,
                    data: json.spends
                }
            ];
        }

        var data = {
            labels: labels,
            datasets: datasets
        };

        var options = {
            responsive: true,
            legendTemplate: "<% %><div style=\"text-align:center;\"><% for (var i=0; i<datasets.length; i++){%><span style=\"margin:0 10px 0 10px;text-align:center\"><span style=\"background-color:<%=datasets[i].strokeColor%>; width:15px; height:10px; display:inline-block\"></span><%if(datasets[i].label){%> <span style=\"font-size:7pt;\" class=\"text-bold\"><%=datasets[i].label%><%}%></span</span><%}%></div><% %>"
        };
        var canvas = $(self.selector).find('#messageChart').get(0);
        if (canvas) {
            var ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            self.messageChart = new Chart(ctx).Bar(data, options);
            var legend = self.messageChart.generateLegend();
            $(self.selector).find('#messageChartLabels').html(legend).find('.export-button').click(function () {
                ch.exportHandler(self.messageChart);
            });
            $(self.selector).find('#messageChart').unbind("click").bind("click", function (evt) {
                if (self.options.window !== "day") {
                    var ord = ch.getOrdinalPositionOfEvent(self.messageChart, evt);

                    //ChartJS, returns -1 if not BAR/LINE clicked
                    //-1 means that the selected date has no data to display
                    if (ord === -1) {
                        return;
                    }

                    self.setWindow(self.goSmaller(self.options.window));
                    $(self.selector).find(".timegranule-buttons").find("[data-timegranule]").removeClass('active');
                    $(self.selector).find(".timegranule-buttons").find("[data-timegranule='" + self.options.window + "']").addClass('active');
                    self.options.from.add(ord, self.options.window + 's');
                    self.setWindow(self.options.window);
                    self.refresh();
                }
            });
        }
    }

    handler6(json) {
        const self = this;
        if (json.unit) {
            $(self.selector).find('#serviceChartXAxisLabel').text(i18n.t("reports.label-" + json.unit));
        }

        if (self.serviceChart) {
            self.serviceChart.destroy();
        }

        var labels = i18n.labels(self.options.from, self.options.window, self.options.queryOptions.unit, json.url.length);
        var data = {
            labels: labels,
            datasets: [
                {
                    label: i18n.t('reports.linkchartlabel'),
                    fillColor: ch.colors.mauveUno.transparent,
                    strokeColor: ch.colors.mauveUno.solid,
                    pointColor: ch.colors.mauveUno.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.mauveUno.solid,
                    data: json.url
                },
                {
                    label: i18n.t('reports.downloadschartlabel'),
                    fillColor: ch.colors.blueDue.transparent,
                    strokeColor: ch.colors.blueDue.solid,
                    pointColor: ch.colors.blueDue.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.blueDue.solid,
                    data: json.downloads
                },
                {
                    label: i18n.t('reports.voucherschartlabel'),
                    fillColor: ch.colors.greenTre.transparent,
                    strokeColor: ch.colors.greenTre.solid,
                    pointColor: ch.colors.greenTre.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.greenTre.solid,
                    data: json.vouchers
                },
                {
                    label: i18n.t('reports.optoutInitlabel'),
                    fillColor: ch.colors.peachQuattro.transparent,
                    strokeColor: ch.colors.peachQuattro.solid,
                    pointColor: ch.colors.peachQuattro.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.peachQuattro.solid,
                    data: json.optoutInit
                },
                {
                    label: i18n.t('reports.survey_label'),
                    fillColor: ch.colors.orangeCinque.transparent,
                    strokeColor: ch.colors.orangeCinque.solid,
                    pointColor: ch.colors.orangeCinque.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.orangeCinque.solid,
                    data: json.surveyInit
                },
                {
                    label: i18n.t('reports.optinVisitslabel'),
                    fillColor: ch.colors.brownSei.transparent,
                    strokeColor: ch.colors.brownSei.solid,
                    pointColor: ch.colors.brownSei.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.brownSei.solid,
                    data: json.optinsVisits
                }
            ]
        };
        var options = {
            responsive: true,
            legendTemplate: "<% %><div style=\"text-align:center;\"><% for (var i=0; i<datasets.length; i++){%><span style=\"margin:0 10px 0 10px;text-align:center\"><span style=\"background-color:<%=datasets[i].strokeColor%>; width:15px; height:10px; display:inline-block\"></span><%if(datasets[i].label){%> <span style=\"font-size:7pt;\" class=\"text-bold\"><%=datasets[i].label%><%}%></span</span><%}%></div><% %>"
        };

        var canvas = $(self.selector).find('#serviceChart').get(0);
        if (canvas) {
            var ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            self.serviceChart = new Chart(ctx).Bar(data, options);

            var legend = self.serviceChart.generateLegend();

            $(self.selector).find('#serviceChartLabels').html(legend).click(function () {
                ch.exportHandler(self.serviceChart);
            });
            $(self.selector).find('#serviceChart').unbind("click").bind("click", function (evt) {
                if (self.options.window !== "day") {
                    var ord = ch.getOrdinalPositionOfEvent(self.serviceChart, evt);
                    if (ord === -1) {
                        return;
                    }
                    console.log('X=' + ord);
                    self.setWindow(self.goSmaller(self.options.window));
                    $(self.selector).find(".timegranule-buttons").find("[data-timegranule]").removeClass('active');
                    $(self.selector).find(".timegranule-buttons").find("[data-timegranule='" + self.options.window + "']").addClass('active');
                    self.options.from.add(ord, self.options.window + 's');
                    self.setWindow(self.options.window);
                    self.refresh();
                }
            });
        }
    }

    handler3(json) {
       const self = this;
       if (json.unit) {
           $(self.selector).find('#pointsChartXAxisLabel').text(i18n.t("reports.label-" + json.unit));
       }

       if (self.pointsChart) {
           self.pointsChart.destroy();
       }

       var totalPointsRedeem = 0;
       var pointsredemptions = 0;

       for (var i = 0; i < json.pointsRedeemed.length; i++) {
           totalPointsRedeem = totalPointsRedeem + json.pointsRedeemed[i];
       }

       for (var j = 0; j < json.pointRedemptions.length; j++) {
           pointsredemptions = pointsredemptions + json.pointRedemptions[j];
       }


       $(self.selector).find("#points-given-count_1-last-week").show().text(totalPointsRedeem);
       var cl = Handlebars.helpers.dynamicFontSize(totalPointsRedeem, $(self.selector).find("#points-given-count_1-last-week").data("font-length"));
       $(self.selector).find("#points-given-count_1-last-week").addClass(cl.toString());

       $(self.selector).find("#point_count_redemptions_1-last-week").show().text(pointsredemptions);
       $(self.selector).find("#point_count_redemptions_1-last-week-title").show().text(i18n.t("reports.pointsredemptionschartlabel", {count: pointsredemptions}));
       cl = Handlebars.helpers.dynamicFontSize(pointsredemptions, $(self.selector).find("#point_count_redemptions_1-last-week").data("font-length"));
       $(self.selector).find("#point_count_redemptions_1-last-week").addClass(cl.toString());

       var labels = i18n.labels(self.options.from, self.options.window, self.options.queryOptions.unit, json.pointRedemptions.length);
       var data = {
           labels: labels,
           datasets: [
               {
                   label: i18n.t('reports.pointsredemptionschartlabel_plural'),
                   fillColor: ch.colors.mauveUno.transparent,
                   strokeColor: ch.colors.mauveUno.solid,
                   pointColor: ch.colors.mauveUno.solid,
                   pointStrokeColor: "#fff",
                   pointHighlightFill: "#fff",
                   pointHighlightStroke: ch.colors.mauveUno.solid,
                   data: json.pointRedemptions
               },
               {
                   label: i18n.t('reports.pointschartlabel_plural'),
                   fillColor: ch.colors.blueDue.transparent,
                   strokeColor: ch.colors.blueDue.solid,
                   pointColor: ch.colors.blueDue.solid,
                   pointStrokeColor: "#fff",
                   pointHighlightFill: "#fff",
                   pointHighlightStroke: ch.colors.blueDue.solid,
                   data: json.pointsRedeemed
               }
           ]
       };
       var options = {
           responsive: true,
           legendTemplate: "<% %><div style=\"text-align:center;\"><% for (var i=0; i<datasets.length; i++){%><span style=\"margin:0 10px 0 10px;text-align:center\"><span style=\"background-color:<%=datasets[i].strokeColor%>; width:15px; height:10px; display:inline-block\"></span><%if(datasets[i].label){%> <span style=\"font-size:7pt;\" class=\"text-bold\"><%=datasets[i].label%><%}%></span</span><%}%></div><% %>"
       };

       var canvas = $(self.selector).find('#pointsChart').get(0);
       if (canvas) {
           var ctx = canvas.getContext("2d");
           ctx.clearRect(0, 0, canvas.width, canvas.height);
           self.pointsChart = new Chart(ctx).Bar(data, options);

           var legend = self.pointsChart.generateLegend();

           $(self.selector).find('#pointsChartLabels').html(legend).click(function () {
               ch.exportHandler(self.pointsChart);
           });
           $(self.selector).find('#pointsChart').unbind("click").bind("click", function (evt) {
               if (self.options.window !== "day") {
                   var ord = ch.getOrdinalPositionOfEvent(self.serviceChart, evt);
                   if (ord === -1) {
                       return;
                   }
                   console.log('X=' + ord);
                   self.setWindow(self.goSmaller(self.options.window));
                   $(self.selector).find(".timegranule-buttons").find("[data-timegranule]").removeClass('active');
                   $(self.selector).find(".timegranule-buttons").find("[data-timegranule='" + self.options.window + "']").addClass('active');
                   self.options.from.add(ord, self.options.window + 's');
                   self.setWindow(self.options.window);
                   self.refresh();
               }
           });
       }
    }

    async refresh() {
        var response;
        try {
            response = await $.ajaxDefaultQ({
                url: '/CampaignCloud/RememberMeController/ping',
                type: 'GET',
                dataType: "json"
            });

            if (response.status !== 'success') {
                throw Error(response);
            }
            console.log(`Going to ${this.options.from.format('ll')}(${this.options.queryOptions.from}) - ${this.options.to.format('ll')}(${this.options.queryOptions.to}) window=${this.options.window} unit=${this.options.queryOptions.unit} dow=${this.options.queryOptions.dow}`);

            const serviceChartData = await $.ajaxDefaultQ({
                url: '/CampaignCloud/Report/ServiceChart',
                type: 'POST',
                data: JSON.stringify(this.options.queryOptions),
                contentType: 'application/json',
                dataType: 'json'
            });
            const pieChartData = await $.ajaxDefaultQ({
                url: '/CampaignCloud/Report/getPieChartData',
                type: 'POST',
                data: JSON.stringify(this.options.queryOptions),
                contentType: 'application/json',
                dataType: 'json'
            });

            this.handler2(pieChartData, serviceChartData);

            const messageChartData = await $.ajaxDefaultQ({
                url: '/CampaignCloud/Report/MessageChart',
                type: 'POST',
                data: JSON.stringify(this.options.queryOptions),
                contentType: 'application/json',
                dataType: 'json'
            });

            const pointsChartData = await $.ajaxDefaultQ({
                url: '/CampaignCloud/Report/PointsChart',
                type: 'POST',
                data: JSON.stringify(this.options.queryOptions),
                contentType: 'application/json',
                dataType: 'json'
            });

            this.handler3(pointsChartData);
            this.handler1(messageChartData, serviceChartData);
            this.handler6(serviceChartData);

            const contactChartData = await $.ajaxDefaultQ({
                url: '/CampaignCloud/Report/ContactChart',
                type: 'POST',
                data: JSON.stringify(this.options.queryOptions),
                contentType: 'application/json',
                dataType: 'json'
            });

            this.handler4(contactChartData);

            const tabsAdditionalData = await $.ajaxDefaultQ({
                url: '/CampaignCloud/Report/TabsAdditionalData',
                type: 'POST',
                data: JSON.stringify(this.options.queryOptions),
                contentType: 'application/json',
                dataType: 'json'
            });

            this.handler5(tabsAdditionalData);

        } catch (e) {
            console.info(e);
            if(response.status != 0) //status = 0 ----> request interrupted by client
                window.open('Login.htm', '_self');
        }
    }

    handler2(resp, sresp) {
        var json = resp;

        var optinsVisits = sresp.optinsVisits;

        var optinsVisited = 0;
        for (var i = 0; i < optinsVisits.length; i++) {
            optinsVisited += optinsVisits[i];
        }

        var surveys = sresp.surveyInit;

        var surveysSent = 0;
        for (var j = 0; j < surveys.length; j++) {
            surveysSent = surveysSent + surveys[j];
        }

        if (this.smsPie) {
            this.smsPie.destroy();
        }
        if (this.linkPie) {
            this.linkPie.destroy();
        }
        if (this.voucherPie) {
            this.voucherPie.destroy();
        }
        if (this.filePie) {
            this.filePie.destroy();
        }
        if (this.surveyPie) {
            this.surveyPie.destroy();
        }
        if (this.optoutPie) {
            this.optoutPie.destroy();
        }

        if (this.optinPie)
            this.optinPie.destroy();

        var totalDl = json.DL[0];
        var clickedDl = json.DL[1];
        var distinctDl = json.DL[2];

        var distinctDlPerc = 0;
        var nonClickedDlPerc = 100;
        if (totalDl > 0) {
            distinctDlPerc =  this.getAppropriatePercentageValue((distinctDl / totalDl * 100), 2)
            nonClickedDlPerc =  this.getAppropriatePercentageValue((100 - distinctDlPerc), 2);
        }

        $(this.selector).find("#file-pie-chart-container").text(i18n.t("reports.filessent", {count: distinctDl}));
        $(this.selector).find("#report-file-1").text(distinctDl);
        cl = Handlebars.helpers.dynamicFontSize(distinctDl, $(this.selector).find("#report-file-1").data("font-length"));
        $(this.selector).find("#report-file-1").addClass(cl.toString());
        $(this.selector).find("#filesDownloadedPercentage").text(distinctDlPerc + "%");
        $(this.selector).find("#fileTitle").text(i18n.t("dashboard.dl", {count: distinctDl}));

        $(this.selector).find("#totalFilesSent").text(totalDl ? totalDl : 0);

        var totalLinks = json.URL[0];
        var clickedLinks = json.URL[1];
        var distinctLinks = json.URL[2];

        var clickedLinksPerc = 0;
        var nonClickedLinksPerc = 100;
        if (totalLinks > 0) {
            clickedLinksPerc =  this.getAppropriatePercentageValue((distinctLinks / totalLinks * 100), 2);
            nonClickedLinksPerc =  this.getAppropriatePercentageValue((100 - clickedLinksPerc), 2);
        }

        $(this.selector).find("#link-pie-chart-container").text(i18n.t("reports.urlssent", {count: clickedLinks}));
        $(this.selector).find("#report-link-1").text(distinctLinks);
        cl = Handlebars.helpers.dynamicFontSize(clickedLinks, $(this.selector).find("#report-link-1").data("font-length"));
        $(this.selector).find("#report-link-1").addClass(cl.toString());
        $(this.selector).find("#urlsClickedPercentage").text(clickedLinksPerc + "%");
        $(this.selector).find("#linkTitle").text(i18n.t("dashboard.clicks", {count: clickedLinks}));

        $(this.selector).find("#totalLinksSent").text(totalLinks ? totalLinks : 0);

        var totalVouchersSent = json.VOUCHER[0];
        var distRedemptions = json.DISTINCT_REDEMPTIONS;

        var clickedVouchersPerc = 0;
        var nonClickedVouchersPerc = 100;
        if (totalVouchersSent > 0) {
            clickedVouchersPerc =  this.getAppropriatePercentageValue((distRedemptions / totalVouchersSent * 100), 2);
            nonClickedVouchersPerc =  this.getAppropriatePercentageValue((100 - clickedVouchersPerc), 2);
        }

        $(this.selector).find("#voucher-pie-chart-container").text(i18n.t("analytics.vouchersSent", {count: totalVouchersSent}));
        $(this.selector).find("#report-voucher-1").text(distRedemptions);
        cl = Handlebars.helpers.dynamicFontSize(distRedemptions, $(this.selector).find("#report-voucher-1").data("font-length"));
        $(this.selector).find("#report-voucher-1").addClass(cl.toString());
        $(this.selector).find("#vouchersRedeemedPercentage").text(clickedVouchersPerc + "%");
        $(this.selector).find("#voucherTitle").text(i18n.t("dashboard.redemption", {count: distRedemptions}));

        $(this.selector).find("#totalVouchersSent").text(totalVouchersSent ? totalVouchersSent : 0);

        var totalSmss = json.SMS[0];
        var deliveredSmss = json.SMS[1];

        var clickedSmsPerc = 0;
        var nonClickedSmsPerc = 100;
        if (totalSmss > 0) {
            clickedSmsPerc =  this.getAppropriatePercentageValue((deliveredSmss / totalSmss * 100), 2);
            nonClickedSmsPerc =  this.getAppropriatePercentageValue((100 - clickedSmsPerc), 2);
        }

        $(this.selector).find("#sms-pie-chart-container").text(i18n.t("dashboard.sms-sent", {count: totalSmss}));
        $(this.selector).find("#report-sms-1").text(deliveredSmss);
        var cl = Handlebars.helpers.dynamicFontSize(deliveredSmss, $(this.selector).find("#report-sms-1").data("font-length"));
        $(this.selector).find("#report-sms-1").addClass(cl.toString());
        $(this.selector).find("#sms-clicked-percentage").text(clickedSmsPerc + "%");
        $(this.selector).find("#smsTitle").text(i18n.t("message.delivered", {count: deliveredSmss}));

        $(this.selector).find("#totalSmsSent").text(totalSmss ? totalSmss : 0);

        var totalSurveysSent = surveysSent;
        var surveyAnswers = json.SURVEY_ANSWERS;

        var surveyAnswerPerc = 0;
        var nonSurveyAnswerPerc = 100;

        if (totalSurveysSent > 0) {
            surveyAnswerPerc =  this.getAppropriatePercentageValue((surveyAnswers / totalSurveysSent * 100), 2);
            nonSurveyAnswerPerc =  this.getAppropriatePercentageValue((100 - surveyAnswerPerc), 2);
        }

        $(this.selector).find("#survey-pie-chart-container").text(i18n.t("reports.Surveyssent", {count: surveyAnswers}));
        $(this.selector).find("#survey-sum-1").text(surveyAnswers);
        cl = Handlebars.helpers.dynamicFontSize(surveyAnswers, $(this.selector).find("#survey-sum-1").data("font-length"));
        $(this.selector).find("#survey-sum-1").addClass(cl.toString());
        $(this.selector).find("#surveysCompletedPercentage").text(surveyAnswerPerc + "%");
        $(this.selector).find("#surveyTitle").text(i18n.t("dashboard.surveyCompleted", {count: surveyAnswers}));

        $(this.selector).find("#totalSurveysSent").text(totalSurveysSent ? totalSurveysSent : 0);

        var options = {
            responsive: false,
            percentageInnerCutout: 75,
            showTooltips: false,
            legendTemplate: "<% for (var i=0; i<segments.length; i++){%><h6 style=\"margin:0\"><span style=\"background-color:<%=segments[i].fillColor%>; width:30px; height:10px; display:inline-block\"></span><%if(segments[i].label){%> <%=segments[i].label%><%}%></h6><%}%>"
        };

        var dataSms = [
            {
                value: clickedSmsPerc,
                color: "rgba(8,212,252,1)",
                label: i18n.t('reports.deliveredlabel')
            },
            {
                value: nonClickedSmsPerc,
                color: "rgba(0,250,242,1)",
                label: i18n.t('reports.undeliveredlabel')
            }
        ];

        var smsPie = $(this.selector).find('#smsPie').get(0);
        if (smsPie) {
            var ctxSmsPie = smsPie.getContext("2d");
            ctxSmsPie.clearRect(0, 0, smsPie.width, smsPie.height);
            this.smsPie = new Chart(ctxSmsPie).Doughnut(dataSms, options);
        }
        var dataLinks = [
            {
                value: clickedLinksPerc,
                color: "rgba(0,217,148,1)",
                label: i18n.t('reports.openedlabel')
            },
            {
                value: nonClickedLinksPerc,
                color: "rgba(72,250,161,1)",
                label: i18n.t('reports.notopenedlabel')
            }
        ];

        var linkPie = $(this.selector).find('#linkPie').get(0);
        if (linkPie) {
            var ctxLinkPie = linkPie.getContext("2d");
            ctxLinkPie.clearRect(0, 0, linkPie.width, linkPie.height);
            this.linkPie = new Chart(ctxLinkPie).Doughnut(dataLinks, options);
            var legend = this.linkPie.generateLegend();
            $(this.selector).find('#linkPieLabels').html(legend).click(() => ch.exportHandler(this.linkPie));
        }

        var dataVouchers = [
            {
                value: clickedVouchersPerc,
                color: "rgba(252,73,124,1)",
                label: i18n.t('reports.redeemedlabel')
            },
            {
                value: nonClickedVouchersPerc,
                color: "rgba(255,130,172,1)",
                label: i18n.t('reports.notredeemedlabel')
            }
        ];


        var voucherPie = $(this.selector).find('#voucherPie').get(0);
        if (voucherPie) {
            var ctxVoucherPie = voucherPie.getContext("2d");
            ctxVoucherPie.clearRect(0, 0, voucherPie.width, voucherPie.height);
            this.voucherPie = new Chart(ctxVoucherPie).Doughnut(dataVouchers, options);
        }

        var dataFiles = [
            {
                value: distinctDlPerc,
                color: "rgba(207,2,155,1)",
                label: i18n.t('reports.downloadedlabel')
            },
            {
                value: nonClickedDlPerc,
                color: "rgba(199,56,170,1)",
                label: i18n.t('reports.notdownloadedlabel')
            }
        ];

        var filePie = $(this.selector).find('#filePie').get(0);
        if (filePie) {
            var ctxFilePie = filePie.getContext("2d");
            ctxFilePie.clearRect(0, 0, filePie.width, filePie.height);
            this.filePie = new Chart(ctxFilePie).Doughnut(dataFiles, options);
        }

        var dataSurveys = [
            {
                value: surveyAnswerPerc,
                color: "rgba(255,128,0,1)",
                label: i18n.t('reports.completedlabel')
            },
            {
                value: nonSurveyAnswerPerc,
                color: "rgba(250,172,88,1)",
                label: i18n.t('reports.notcompletedlabel')
            }
        ];

        var surveyPie = $(this.selector).find('#surveyPie').get(0);
        if (surveyPie) {
            var ctxSurveyPie = surveyPie.getContext("2d");
            ctxSurveyPie.clearRect(0, 0, surveyPie.width, surveyPie.height);
            this.surveyPie = new Chart(ctxSurveyPie).Doughnut(dataSurveys, options);
        }

        var totalSentOptouts = json.OPTOUT[0];
        var optoutsDone = json.OPTOUT[1];
        var optoutsDoneDistinct = json.OPTOUT[2];

        var clickedOptoutsPerc = 0;
        var nonClickedOptoutsPerc = 100;
        if (totalSentOptouts > 0) {
            clickedOptoutsPerc = this.getAppropriatePercentageValue((optoutsDone / totalSentOptouts * 100), 2);
            nonClickedOptoutsPerc =  this.getAppropriatePercentageValue((100 - clickedOptoutsPerc), 2);
        }

        $(this.selector).find('#optoutsClickedPercentage').text(clickedOptoutsPerc + '%');
        $(this.selector).find("#optouts-pie-chart-container").text(i18n.t("dashboard.optout", {count: optoutsDoneDistinct}));
        $(this.selector).find("#report-optouts-1").text(optoutsDoneDistinct);
        cl = Handlebars.helpers.dynamicFontSize(optoutsDoneDistinct, $(this.selector).find("#clicked-on-optout-1").data("font-length"));
        $(this.selector).find("#creport-optouts-1").addClass(cl.toString());
        $(this.selector).find('#optoutsTitle').text(i18n.t("message.optouts", {count: optoutsDoneDistinct}));
        if (clickedOptoutsPerc > 100) {
            nonClickedOptoutsPerc = 0;
        }

        $(this.selector).find("#totalOptoutsSent").text(totalSentOptouts);

        var dataOptouts = [
            {
                value: clickedOptoutsPerc,
                color: "rgba(22,79,127,1)",
                label: i18n.t('reports.openedlabel')
            },
            {
                value: nonClickedOptoutsPerc,
                color: "rgba(39,143,229,1)",
                label: i18n.t('reports.notopenedlabel')
            }
        ];
        options = {
            responsive: false,
            legendTemplate: "<% for (var i=0; i<segments.length; i++){%><h6 style=\"margin:0\"><span style=\"background-color:<%=segments[i].fillColor%>; width:15px; height:10px; display:inline-block\"></span><%if(segments[i].label){%> <%=segments[i].label%><%}%></h6><%}%>",
            percentageInnerCutout: 75,
            showTooltips: false
        };

        var optoutPie = $(this.selector).find('#optoutPie').get(0);
        if (optoutPie) {
            var ctxOptoutPie = optoutPie.getContext("2d");
            ctxOptoutPie.clearRect(0, 0, optoutPie.width, optoutPie.height);
            this.optoutPie = new Chart(ctxOptoutPie).Doughnut(dataOptouts, options);
        }

        var optinsAcquisited = json.OPTIN_ACQUISITIONS;
        var acquisitedOptinsPercentage = 0;
        var noAcquisitedOptinsPercentage = 100;

        if (optinsVisited) {
            acquisitedOptinsPercentage =  this.getAppropriatePercentageValue((optinsAcquisited / optinsVisited * 100), 2);
            noAcquisitedOptinsPercentage =  this.getAppropriatePercentageValue((100 - acquisitedOptinsPercentage), 2);
        }

        $(this.selector).find('#optin-acquisitions').text(optinsAcquisited);
        cl = Handlebars.helpers.dynamicFontSize(optinsAcquisited, $(this.selector).find('#optin-acquisitions').data('font-length'));
        $(this.selector).find("#optin-acquisitions").addClass(cl.toString());
        $(this.selector).find("#optin-completed-percentage").text(acquisitedOptinsPercentage + "%");
        $(this.selector).find("#optins-pie-chart-container").text(i18n.t("optin.view", {count: optinsVisited}));

        if (acquisitedOptinsPercentage > 100)
            noAcquisitedOptinsPercentage = 0;

        $(this.selector).find("#totalOptinVisited").text(optinsVisited ? optinsVisited : 0);

        dataLinks = [
            {
                value: acquisitedOptinsPercentage,
                color: "rgba(127, 6, 0, 1)",
                scaleShowLabels: true
            },
            {
                value: noAcquisitedOptinsPercentage,
                color: "rgba(255, 84, 76, 1)",
                scaleShowLabels: true
            }
        ];

        options = {
            responsive: false,
            scaleShowLabels: false,
            percentageInnerCutout: 75,
            showTooltips: false
        };

        var optinPie = $(this.selector).find('#optinPie').get(0);
        if (optinPie) {
            var ctxOptinPie = optinPie.getContext("2d");
            ctxOptinPie.clearRect(0, 0, optinPie.width, optinPie.height);
            this.optinPie = new Chart(ctxOptinPie).Doughnut(dataLinks, options);
        }

    }

    handler4(json) {
        if (json.unit) {
            $(this.selector).find('#contactChartXAxisLabel').text(i18n.t("reports.label-" + json.unit));
        }

        var contactsAdded = 0;
        var groupsCreated = 0;

        for (var i = 0; i < json.contactsAdded.length; i++) {
            contactsAdded = contactsAdded + json.contactsAdded[i];
        }

        for (var j = 0; j < json.groupsAdded.length; j++) {
            groupsCreated = groupsCreated + json.groupsAdded[j];
        }


        $(this.selector).find("#contact-count_1-last-week").show().text(contactsAdded);
        var cl = Handlebars.helpers.dynamicFontSize(contactsAdded, $(this.selector).find("#contact-count_1-last-week").data("font-length"));
        $(this.selector).find("#contact-count_1-last-week").addClass(cl.toString());
        $(this.selector).find("#contact-text-last-week").text(i18n.t("dashboard.newContact", {count: contactsAdded}));

        $(this.selector).find("#group-count_1-last-week").show().text(groupsCreated);
        cl = Handlebars.helpers.dynamicFontSize(groupsCreated, $(this.selector).find("#group-count_1-last-week").data("font-length"));
        $(this.selector).find("#group-count_1-last-week").addClass(cl.toString());
        $(this.selector).find("#group-text-last-week").text(i18n.t("dashboard.groups", {count: groupsCreated}));


        if (this.contactChart) {
            this.contactChart.destroy();
        }

        var labels = i18n.labels(this.options.from, this.options.window, this.options.queryOptions.unit, json.contactsAdded.length);

        var data = {
            labels: labels,
            datasets: [
                {
                    label: i18n.t('reports.newcontactslabel'),
                    fillColor: ch.colors.mauveUno.transparent,
                    strokeColor: ch.colors.mauveUno.solid,
                    pointColor: ch.colors.mauveUno.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.mauveUno.solid,
                    data: json.contactsAdded.slice(0, labels.length)
                },
                {
                    label: i18n.t('reports.newgroupslabel'),
                    fillColor: ch.colors.blueDue.transparent,
                    strokeColor: ch.colors.blueDue.solid,
                    pointColor: ch.colors.blueDue.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.blueDue.solid,
                    data: json.groupsAdded.slice(0, labels.length)
                },
                {
                    label: i18n.t('reports.optoutlabel'),
                    fillColor: ch.colors.greenTre.transparent,
                    strokeColor: ch.colors.greenTre.solid,
                    pointColor: ch.colors.greenTre.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.greenTre.solid,
                    data: json.contactsBlocked.slice(0, labels.length)
                },
                {
                    label: i18n.t('reports.contactsservedlabel'),
                    fillColor: ch.colors.peachQuattro.transparent,
                    strokeColor: ch.colors.peachQuattro.solid,
                    pointColor: ch.colors.peachQuattro.solid,
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: ch.colors.peachQuattro.solid,
                    data: json.contactsServed.slice(0, labels.length)
                }
            ]
        };

        var options = {
            responsive: true,
            legendTemplate: "<% %><div style=\"text-align:center;\"><% for (var i=0; i<datasets.length; i++){%><span style=\"margin:0 10px 0 10px;text-align:center\"><span style=\"background-color:<%=datasets[i].strokeColor%>; width:15px; height:10px; display:inline-block\"></span><%if(datasets[i].label){%> <span style=\"font-size:7pt;\" class=\"text-bold\"><%=datasets[i].label%><%}%></span</span><%}%></div><% %>"
        };

        var canvas = $(this.selector).find('#contactChart').get(0);
        if (canvas) {
            var ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            this.contactChart = new Chart(ctx).Bar(data, options);
            var legend = this.contactChart.generateLegend();
            $(this.selector).find('#contactChartLabels').html(legend).click(() => {
                ch.exportHandler(this.contactChart);
            });
            $(this.selector).find('#contactChart').unbind("click").bind("click", evt => {
                if (this.options.window !== "day") {
                    var ord = ch.getOrdinalPositionOfEvent(this.contactChart, evt);
                    if (ord === -1) {
                        return;
                    }
                    console.log('X=' + ord);
                    this.setWindow(this.goSmaller(this.options.window));
                    $(this.selector).find(".timegranule-buttons").find("[data-timegranule]").removeClass('active');
                    $(this.selector).find(".timegranule-buttons").find("[data-timegranule='" + this.options.window + "']").addClass('active');
                    this.options.from.add(ord, this.options.window + 's');
                    this.setWindow(this.options.window);
                    this.refresh();
                }
            });
        }
    }

    handler5(json) {

        var countriesCountLastWeek = json.countriesNumber;
        var smsCampaignsLastWeek = json.smsCampaignExecuted;
        var emailCampaignsLastWeek = json.emailCampaignExecuted;
        var campaignLastWeek = smsCampaignsLastWeek + emailCampaignsLastWeek;
        var contactsReceiveSms = json.contactsReceivedSms;
        var contactsReceiveEmail = json.contactsReceivedEmail;

        $(this.selector).find("#countries-count-last-week").text(countriesCountLastWeek ? countriesCountLastWeek : 0);
        $(this.selector).find("#countries-last-week").text(i18n.t("dashboard.countries", {count: countriesCountLastWeek}));


        $(this.selector).find("#campaign-sms-1-last-week").show().text(smsCampaignsLastWeek ? smsCampaignsLastWeek : 0);
        var cl = Handlebars.helpers.dynamicFontSize(smsCampaignsLastWeek, $(this.selector).find("#campaign-sms-1-last-week").data("font-length"));
        $(this.selector).find("#campaign-sms-1-last-week").addClass(cl.toString());


        $(this.selector).find("#campaign-email-1-last-week").show().text(emailCampaignsLastWeek ? emailCampaignsLastWeek : 0);
        cl = Handlebars.helpers.dynamicFontSize(emailCampaignsLastWeek, $(this.selector).find("#campaign-email-1-last-week").data("font-length"));
        $(this.selector).find("#campaign-email-1-last-week").addClass(cl.toString());


        $(this.selector).find("#campaigns-ended-1-last-week").show().text(campaignLastWeek ? campaignLastWeek : 0);
        cl = Handlebars.helpers.dynamicFontSize(campaignLastWeek, $(this.selector).find("#campaigns-ended-1-last-week").data("font-length"));
        $(this.selector).find("#campaigns-ended-1-last-week").addClass(cl.toString());
        $(this.selector).find("#campaigns-ended-last-week-text").text(i18n.t("dashboard.campaigns", {count: campaignLastWeek}));


        $(this.selector).find("#contacts_count_sms_1-last-week").show().text(contactsReceiveSms ? contactsReceiveSms : 0);
        $(this.selector).find("#contacts_count_sms_1-last-week-title").show().text(i18n.t("dashboard.contacts", {count: contactsReceiveSms}));
        cl = Handlebars.helpers.dynamicFontSize(contactsReceiveSms, $(this.selector).find("#contacts_count_sms_1-last-week").data("font-length"));
        $(this.selector).find("#contacts_count_sms_1-last-week").addClass(cl.toString());


        $(this.selector).find("#contacts_count_email_1-last-week").show().text(contactsReceiveEmail ? contactsReceiveEmail : 0);
        $(this.selector).find("#contacts_count_email-text-last-week").show().text(i18n.t("dashboard.contacts", {count: contactsReceiveEmail}));
        cl = Handlebars.helpers.dynamicFontSize(contactsReceiveEmail, $(this.selector).find("#contacts_count_email_1-last-week").data("font-length"));
        $(this.selector).find("#contacts_count_email_1-last-week").addClass(cl.toString());
    }

    goSmaller(timegranule) {
        switch (timegranule) {
            case "week":
                return "*day";
            case "month":
                return "*day";
            case "year":
                return "month";
            case "all":
                return this.options.unitAll === "day" ? "*day" : this.options.unitAll;
        }
    }
}

export default ReportMessageChartSimpleView;
